import axios from "axios"
import { ACTIVE_TAB, LOADER_STATUS,FILE_DATA, SET_ENTITY_LIST, PROFILE_DATA, STORE_GSTIN_ITC04, STORE_PERIOD } from "./constants";
import { getLocalStorage } from "components/Helper/Helper";
import { Config } from "../../Config";
import { toast } from "react-toastify";

function errNot(msg){
  toast.success(`${msg}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
  }
function errNotError(msg){
  toast.error(`${msg}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
  }
export function loader(status) {
    return {
      type: LOADER_STATUS,
      loaderStatus: status,
    };
}
// action creator
export function setViewData(fileData) {
  return {
    type: FILE_DATA,
    fileData: fileData,
  };
}
export function storeSelectedGstinITC04(payload){
  return{
    type: STORE_GSTIN_ITC04,
    selectedGstin: payload
  }
}

export function setEntityList(data){
  return {
    type: SET_ENTITY_LIST,
    payload: data,
  }};

  export function profileInfo(payload) {
    return {
      type: PROFILE_DATA,
      profileData: payload,
    };
  };  
  export function setPeriodStore(startDate, endDate){
    return{
      type: STORE_PERIOD,
      date: {startDate, endDate}
    }
}
//  middleware k thorugh redux

export function setActiveTabId(id){
  return{
    type: ACTIVE_TAB,
    tabId: id,
  }
}

export function getEntityList(){
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      user_id:getLocalStorage("user_id").user_id
    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getCompanyByUserId`,
        data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            let entityList = response.data.data.map((entity)=>{
              return {value:entity.company_id, label:entity.name}
            });
            dispatch(setEntityList(entityList));
            resolve(true);
          }else{
            resolve([]);
          }
          dispatch(loader(false));
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  }
};

export const getGstinByEntity = (value) => {
 
  return (dispatch) => {
    dispatch(loader(true));
    let data = {
      entity_id: value,
      user_id:getLocalStorage("user_id").user_id,
      profile_type: "GST"

    };
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGstnListByEntityId`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      })
        .then((response) => {
          if (response.data.error != 1) {
            const gstinList = (response.data?.data || []).filter(
              (item) => item?.profile_type === "GST"
            );
            if(gstinList.length > 0){             
                const sortedGstin = gstinList.sort((a, b) =>
                a.gstin > b.gstin ? 1 : -1
                );
                dispatch(profileInfo(sortedGstin));
                resolve(sortedGstin)
            }else{
              dispatch(profileInfo([]));
              resolve([])
            }
          }
          dispatch(loader(false));         
        })
        .catch((error) => {
          dispatch(loader(false));
          console.log(error);
          reject(true);
        });
    });
  };
};